import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import styles from './FormModal.module.scss';

interface FormModalHeaderProps {
    title: string;
    onClose: () => void;
    showCloseButton?: boolean;
}


const FormModalHeader: React.FC<FormModalHeaderProps> = ({ title, onClose, showCloseButton = true }) => (
    <div className={styles.header}>
        <h2 className={styles.headerTitle}>{title}</h2>
        {showCloseButton && (
            <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
                <CloseIcon sx={{ fontSize: '1rem' }} />
            </button>
        )}
    </div>
);

export default FormModalHeader;
